import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router';
import axios from 'axios';
import moment from 'moment';// import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ja from 'date-fns/locale/ja';
import Loading from '../Loading/Loading';
import { useHistory, generatePath } from 'react-router-dom';
import constClass from '../../Constants/Constants';
registerLocale('ja', ja);

const AppLottery = (props) => {
  const { user } = props;
  const { siteId, mallId } = useParams();
  const [lockData, setLockData] = useState(false);
  const [masterData, setMasterData] = useState([]);
  const [customerrankData, setCustomerRankData] = useState([]);
  const { addToast } = useToasts();
  const history = useHistory();

  const PAGE_SIZE = 5;

  const [values, setValues] = useState({
    site_id: null,
    mall_id: null,
    lottery_id: null,
    lottery_type: null,
    lottery_start: null,
    lottery_end: null,
    lottery_title: '',
    lottery_detail: '',
    lottery_fail_message: '',
    rank_id: [],
    uploadfile: null,
    uploadfiletype: null,
    deletefile: null,
    uploadfile2: null,
    uploadfiletype2: null,
    deletefile2: null,
  });

  const [searchKeyword, setSearchKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const refreshMaster = useCallback(async () => {
    setLockData(true);
    var resdata = null
    try {
      const jwt = localStorage.getItem('jwt');
      resdata = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/applottery/backyard/${siteId}/${mallId}`, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      })).data;      

      var reg_params = { site_id: siteId };
      const customerrankdata = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/mastercustomerrank/search`, reg_params, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      })).data;
      customerrankdata.sort((a, b) => a.point_lower - b.point_lower)
      setCustomerRankData(customerrankdata);

      if (Array.isArray(resdata) && resdata.length > 0) {
        const processedData = resdata.map((item) => ({
          site_id: siteId,
          mall_id: mallId,
          lottery_id: item.lottery_id || null,
          lottery_type: item.lottery_type || constClass.LOTTERY_TYPE.DAILYONCE,
          lottery_start: item.lottery_start ? moment(item.lottery_start, 'YYYYMMDD').toDate() : null,
          lottery_end: item.lottery_end ? moment(item.lottery_end, 'YYYYMMDD').toDate() : null,
          lottery_title: item.lottery_title || '',
          lottery_detail: item.lottery_detail || '',
          lottery_fail_message: item.lottery_fail_message || '',
          rank_id: item.app_lottery_ranks ? item.app_lottery_ranks.map((rank) => rank.rank_id) : [],
          uploadfile: item.lottery_before_image_url ? `/${siteId}/${constClass.LOTTERY_BEFORE_IMAGE_DIR + item.lottery_before_image_url}` : null,
          uploadfiletype: null,
          deletefile: null,
          uploadfile2: item.lottery_after_image_url ? `/${siteId}/${constClass.LOTTERY_AFTER_IMAGE_DIR + item.lottery_after_image_url}` : null,
          uploadfiletype2: null,
          deletefile2: null,
          upd_date: item.upd_date || null,
        }));

        setMasterData(processedData);
      } else {
        // resdataが空の場合の処理
        setMasterData([]);
      }
    } catch (error) {
      console.error(error);
      setMasterData([]);
    } finally {
      setLockData(false);
    }
  }, [siteId, mallId]);

  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  }

  const handleChangeFile = (e) => {
    const value = e.target.files[0];
    var reader = new FileReader();
    reader.onloadend = () => {
      setValues({
        ...values,
        uploadfile: reader.result,
        uploadfiletype: value.type,
        deletefile: values.lottery_before_image_url
      });
    }
    reader.readAsDataURL(value);
  }

  const handleDeleteFile = () => {
    setValues({ ...values, uploadfile: null, uploadfiletype: null, deletefile: values.lottery_image_url });
  }

   const handleChangeFile2 = (e) => {
    const value = e.target.files[0];
    var reader = new FileReader();
    reader.onloadend = () => {
      setValues({
        ...values,
        uploadfile2: reader.result,
        uploadfiletype2: value.type,
        deletefile2: values.lottery_after_image_url
      });
    }
    reader.readAsDataURL(value);
  }

  const handleDeleteFile2 = () => {
    setValues({ ...values, uploadfile2: null, uploadfiletype2: null, deletefile2: values.lottery_after_image_url });
  }

  const registerData = async () => {
    try {
      if (!values.lottery_start || !values.lottery_end || moment(values.lottery_start) > moment(values.lottery_end)) {
        window.alert('期間指定が間違っています。');
        return;
      }
      if (!values.lottery_type) {
        window.alert('抽選区分が選択されていません。');
        return;
      }
      var data = {
        ...values,
        site_id: siteId,
        mall_id: mallId,
        lottery_start: moment(values.lottery_start).format('YYYYMMDD'),
        lottery_end: moment(values.lottery_end).format('YYYYMMDD'),
        rank_id: Array.isArray(values.rank_id) ? [...new Set(values.rank_id.map(Number))] : [],
        upd_name: user.userId
      };
      if (data.uploadfiletype === null) data.uploadfile = null;
      if (data.uploadfiletype2 === null) data.uploadfile2 = null;
      if (!window.confirm(`登録してよろしいですか？`)) {
        return;
      }
      setLockData(true);

      const jwt = localStorage.getItem('jwt');
      const res = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/applottery/backyard/${siteId}/${mallId}`, data, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      }));
      if (res && res.data && res.data.result) {
        //正常終了
        if (!data.lottery_id) {
          addToast(`登録完了しました。`, { appearance: 'success', autoDismiss: true });
        } else {
          addToast(`更新完了しました。`, { appearance: 'success', autoDismiss: true });
        }
        refreshMaster();
        handleResetClick();
      } else {
        console.log(res.data)
        //異常終了
        addToast((res && res.data && res.data.msg) ? res.data.msg : "エラーが発生しました", { appearance: 'error', autoDismiss: true });
      }
    } catch (error) {
      console.log(error, user)
    } finally {
      setLockData(false);
    }
  }

  /* 編集ボタン押下 */
  const handleUpdateClick = (data) => {
    const temp = {
      ...data,
      deletefile: null,
      deletefile2: null,
      uploadfiletype: null,
      uploadfiletype2: null,
      lottery_start: moment(data.lottery_start, 'YYYYMMDD').toDate(),
      lottery_end: moment(data.lottery_end, 'YYYYMMDD').toDate(),
    };
    setValues(temp);
  };

  /* DB削除 */
  const handleDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');

    if (!window.confirm(`抽選情報を削除します。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: siteId,
      mall_id: mallId,
      lottery_id: values.lottery_id,
      upd_date: values.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/applottery/backyard/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
      if (res && res.data && res.data.result) {
        //正常終了
        addToast(`削除しました。`, { appearance: 'success', autoDismiss: true });
        refreshMaster();
        handleResetClick();
      } else {
        console.log(res.data)
        //異常終了
        addToast((res && res.data && res.data.msg) ? res.data.msg : "エラーが発生しました", { appearance: 'error', autoDismiss: true });
      }
    } catch (error) {
      console.log(error, user)
    } finally {
      setLockData(false);
    }
  }

  /* RESETボタン押下 */
  const handleResetClick = () => {
    setValues({
      site_id: null,
      mall_id: null,
      lottery_id: null,
      lottery_type: null,
      lottery_start: null,
      lottery_end: null,
      lottery_title: '',
      lottery_detail: '',
      lottery_fail_message: '',
      rank_id: [],      
      uploadfile: null,
      uploadfiletype: null,
      deletefile: null,
      uploadfile2: null,
      uploadfiletype2: null,
      deletefile2: null,
    });
  }

  useEffect(() => {
    refreshMaster();
  }, [refreshMaster]);

  const setDateValue = (value, name) => {
    console.log(value)
    setValues({ ...values, [name]: value });
  }

  const handleRankIdChange = (e) => {
    const value = e.target.value;
    let newRankIds = Array.isArray(values.rank_id) ? [...values.rank_id] : [];
    
    if (e.target.checked) {
      if (!newRankIds.includes(value)) {
        newRankIds.push(value);
      }
    } else {
      newRankIds = newRankIds.filter((id) => String(id) !== String(value));
    }

    // valuesの状態を更新
    setValues((prevData) => ({
      ...prevData,
      rank_id: newRankIds,
    }));
  };


  const renderUpdateButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleUpdateClick(data)}>
        編集
      </button>
    )
  }

  const renderAppLotteryInfoButton = (data) => {
    return (
      <button type="button"
        className={`btn btn-primary mx-1`}
        onClick={() => history.push(generatePath(`${props.match.path}applotterybonus/${data.lottery_id}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId, lotteryId: data.lottery_id }))}
      >
        ボーナス情報設定
      </button>
    )
  }

  const renderList = () => {
    const filteredData = masterData.filter(data =>
      !searchKeyword || data.lottery_title.includes(searchKeyword)
    );
    const totalPages = Math.ceil(filteredData.length / PAGE_SIZE);
    const pagedData = filteredData.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

    return (
      <div className="row mb-3 p-0 mt-2">
        <div className="col-12 mb-2">
          <div className="row">
            <input
              type="text"
              className="col-4 form-control"
              placeholder="抽選タイトルで絞り込み"
              value={searchKeyword}
              onChange={e => { setSearchKeyword(e.target.value); setCurrentPage(1); }}
            />
          </div>
        </div>
        <div className="col-12 p-0">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <span className="small text-muted">{filteredData.length}件中 {Math.min((currentPage - 1) * PAGE_SIZE + 1, filteredData.length)}〜{Math.min(currentPage * PAGE_SIZE, filteredData.length)}件表示</span>
            {totalPages > 1 && (
              <nav>
                <ul className="pagination pagination-sm mb-0">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(p => p - 1)}>‹</button>
                  </li>
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                    <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(page)}>{page}</button>
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(p => p + 1)}>›</button>
                  </li>
                </ul>
              </nav>
            )}
          </div>
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">
                  抽選ID
                </td>
                <td className="text-center align-middle">
                  抽選タイトル
                </td>
                <td className="text-center align-middle">
                  抽選期間
                </td>
                <td className="text-center align-middle">
                  抽選区分
                </td>
                <td className="text-center align-middle">
                  処理
                </td>
              </tr>
            </thead>
            <tbody>
              {pagedData.map((data) => (
                <tr key={data.lottery_id}>
                  {/* 抽選ID */}
                  <td className="text-center align-middle">
                    {data.lottery_id}
                  </td>
                  {/* 抽選タイトル */}
                  <td className="text-center align-middle">
                    {data.lottery_title}
                  </td>
                  {/* 抽選期間 */}
                  <td className="text-center align-middle">
                    {`${moment(data.lottery_start).format('YYYY/MM/DD')} ~ ${moment(data.lottery_end).format('YYYY/MM/DD')}`}
                  </td>
                  {/* 抽選区分 */}
                  <td className="text-center align-middle">
                    {constClass.LOTTERY_TYPE_NAME[data.lottery_type]}
                  </td>
                  {/* 処理 */}
                  <td className="text-center align-middle text-nowrap">
                    {renderUpdateButton(data)}
                    {renderAppLotteryInfoButton(data)}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  const renderInput = () => {
    return (
      <div className="row mx-0 my-2 px-1-env">
        <div className="col-10">
          <div className="row my-3">
            <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
              <span>抽選期間</span>
            </div>
            <div className="col-4 text-center">
              <DatePicker className="custom-select text-left"
                locale="ja" dateFormat="yyyyMMdd" monthsShown="1" id={'lottery_start'} name={'lottery_start'}
                popperPlacement='bottom'
                selected={values && values.lottery_start ? values.lottery_start : null}
                onChange={(value) => setDateValue(value, "lottery_start")}
                placeholderText="- 選択 -"
                autoComplete='off'
                isClearable={true}
                onFocus={(e) => e.target.blur()}
              />
            </div>
            <div className="col-1 text-center">～</div>
            <div className="col-4 text-center">
              <DatePicker className="custom-select text-left"
                locale="ja" dateFormat="yyyyMMdd" monthsShown="1" id={'lottery_end'} name={'lottery_end'}
                popperPlacement='bottom'
                selected={values && values.lottery_end ? values.lottery_end : null}
                onChange={(value) => setDateValue(value, "lottery_end")}
                placeholderText="- 選択 -"
                autoComplete='off'
                isClearable={true}
                onFocus={(e) => e.target.blur()}
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
              <label htmlFor="lottery_type">抽選区分</label>
            </div>
            <div className="col-5 align-self-center">
              <select className="form-control" id="lottery_type" name="lottery_type" value={values.lottery_type || ''} onChange={handleChange}>
                <option value="">- 選択 -</option>
                <option key={constClass.LOTTERY_TYPE_NAME.DAILYONCE} value={constClass.LOTTERY_TYPE.DAILYONCE}>{constClass.LOTTERY_TYPE_NAME.DAILYONCE}</option>
                <option key={constClass.LOTTERY_TYPE_NAME.ONETIME} value={constClass.LOTTERY_TYPE.ONETIME}>{constClass.LOTTERY_TYPE_NAME.ONETIME}</option>
              </select>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
              <label htmlFor="ticket_summary">抽選タイトル</label>
            </div>
            <div className="col-5 align-self-center">
              <textarea className="form-control" rows="3" name="lottery_title" id="lottery_title" value={values.lottery_title} onChange={handleChange}></textarea>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
              <label htmlFor="lottery_detail">抽選詳細</label>
            </div>
            <div className="col-5 align-self-center">
              <textarea className="form-control" rows="3" name="lottery_detail" id="lottery_detail" value={values.lottery_detail} onChange={handleChange}></textarea>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
              <label htmlFor="remarks">抽選前画像</label>
            </div>
            <div className="col-5 align-self-center">
              {!(values.uploadfile) && <input type="file" className="form-control-file" name="lotteryBeforeImage" id="lotteryBeforeImage" value="" onChange={handleChangeFile} onClick={e => (e.target.value = null)} />}
              {values.uploadfile && <object id="uploadfileview" className="w-100" data={values.uploadfile} type={values.uploadfiletype}><img className="w-100" src={values.uploadfile} alt='uploadfile' /></object>}
              {values.uploadfile && <input type="button" className="form-controll" name="deletefile" id="deletefile" onClick={handleDeleteFile} value="ファイル削除" />}
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
              <label htmlFor="lottery_fail_message">抽選後はずれメッセージ</label>
            </div>
            <div className="col-5 align-self-center">
              <textarea className="form-control" rows="3" name="lottery_fail_message" id="lottery_fail_message" value={values.lottery_fail_message} onChange={handleChange}></textarea>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
              <label htmlFor="remarks">抽選後はずれ画像</label>
            </div>
            <div className="col-5 align-self-center">
              {!(values.uploadfile2) && <input type="file" className="form-control-file" name="lotteryAfterImage" id="lotteryAfterImage" value="" onChange={handleChangeFile2} onClick={e => (e.target.value = null)} />}
              {values.uploadfile2 && <object id="uploadfileview" className="w-100" data={values.uploadfile2} type={values.uploadfiletype2}><img className="w-100" src={values.uploadfile2} alt='uploadfile2' /></object>}
              {values.uploadfile2 && <input type="button" className="form-controll" name="deletefile2" id="deletefile2" onClick={handleDeleteFile2} value="ファイル削除" />}
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
              <span>利用可能ランクID</span>
            </div>
            <div className="col-9 d-flex align-items-center">
              {customerrankData.map((rank, index) => (
                <div className="form-check mx-2" key={rank.rank_id}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`rank_id_${rank.rank_id}`}
                    name="rank_id"
                    value={rank.rank_id}
                    checked={values && Array.isArray(values.rank_id) && values.rank_id.map(String).includes(String(rank.rank_id))}
                    onChange={handleRankIdChange}
                  />
                  <label className="form-check-label mx-1" htmlFor={`rank_id_${rank.rank_id}`}>
                    {rank.rank_name}
                  </label>
                </div>
              ))}
              <span className='ml-4'>※未選択の場合、全ランクで利用可能です。</span>
            </div>
          </div>
        </div>
        <div className='col-12'>
          <div className="row my-3 mt-4 d-flex justify-content-center">
            <div className="col-2 text-center">
              <button type="button"
                className={`btn btn-primary mx-1 w-100 text-nowrap`}
                disabled={lockData}
                onClick={() => registerData()}>
                登録</button>
            </div>
            <div className="col-2 text-center">
              <button type="button"
                className={`btn btn-primary mx-1 w-100 text-nowrap`}
                disabled={lockData || values.lottery_id === null}
                onClick={() => handleDeleteClick()}>
                削除</button>
            </div>
            <div className="col-2 text-center">
              <button type="button"
                className={`btn btn-primary mx-1 w-100 text-nowrap`}
                disabled={lockData}
                onClick={() => handleResetClick()}>
                リセット</button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="container">
      {/* <div className="row mx-0 my-2 px-1-env my-4">
        <div className='mx-4 h4'>抽選設定</div>
        {renderAppLotteryInfoButton()}
      </div> */}
  {/* {masterData &&
        <div className="row mx-0 my-2 px-1-env">
          <div className="col-10">
            <div className="row my-3">
              <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
                <span>抽選期間</span>
              </div>
              <div className="col-4 text-center">
                <DatePicker className="custom-select text-left"
                  locale="ja" dateFormat="yyyyMMdd" monthsShown="1" id={'lottery_start'} name={'lottery_start'}
                  popperPlacement='bottom'
                  selected={masterData && masterData.lottery_start ? masterData.lottery_start : null}
                  onChange={(value) => setDateValue(value, "lottery_start")}
                  placeholderText="- 選択 -"
                  autoComplete='off'
                  isClearable={true}
                  onFocus={(e) => e.target.blur()}
                />
              </div>
              <div className="col-1 text-center">～</div>
              <div className="col-4 text-center">
                <DatePicker className="custom-select text-left"
                  locale="ja" dateFormat="yyyyMMdd" monthsShown="1" id={'lottery_end'} name={'lottery_end'}
                  popperPlacement='bottom'
                  selected={masterData && masterData.lottery_end ? masterData.lottery_end : null}
                  onChange={(value) => setDateValue(value, "lottery_end")}
                  placeholderText="- 選択 -"
                  autoComplete='off'
                  isClearable={true}
                  onFocus={(e) => e.target.blur()}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
                <label htmlFor="lottery_type">抽選区分</label>
              </div>
              <div className="col-5 align-self-center">
                <select className="form-control" id="lottery_type" name="lottery_type" value={masterData.lottery_type ?? ''} onChange={handleChange}>
                  <option value="">- 選択 -</option>
                  <option key={constClass.LOTTERY_TYPE_NAME.DAILYONCE} value={constClass.LOTTERY_TYPE.DAILYONCE}>{constClass.LOTTERY_TYPE_NAME.DAILYONCE}</option>
                  <option key={constClass.LOTTERY_TYPE_NAME.ONETIME} value={constClass.LOTTERY_TYPE.ONETIME}>{constClass.LOTTERY_TYPE_NAME.ONETIME}</option>
                </select>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
                <label htmlFor="ticket_summary">抽選タイトル</label>
              </div>
              <div className="col-5 align-self-center">
                <textarea className="form-control" rows="3" name="lottery_title" id="lottery_title" value={masterData.lottery_title ?? ''} onChange={handleChange}></textarea>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
                <label htmlFor="lottery_detail">抽選詳細</label>
              </div>
              <div className="col-5 align-self-center">
                <textarea className="form-control" rows="3" name="lottery_detail" id="lottery_detail" value={masterData.lottery_detail ?? ''} onChange={handleChange}></textarea>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
                <label htmlFor="remarks">抽選前画像</label>
              </div>
              <div className="col-5 align-self-center">
                {!(masterData.uploadfile) && <input type="file" className="form-control-file" name="lotteryBeforeImage" id="lotteryBeforeImage" value="" onChange={handleChangeFile} onClick={e => (e.target.value = null)} />}
                {masterData.uploadfile && <object id="uploadfileview" className="w-100" data={masterData.uploadfile} type={masterData.uploadfiletype}><img className="w-100" src={masterData.uploadfile} alt='uploadfile' /></object>}
                {masterData.uploadfile && <input type="button" className="form-controll" name="deletefile" id="deletefile" onClick={handleDeleteFile} value="ファイル削除" />}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
                <label htmlFor="lottery_fail_message">抽選後はずれメッセージ</label>
              </div>
              <div className="col-5 align-self-center">
                <textarea className="form-control" rows="3" name="lottery_fail_message" id="lottery_fail_message" value={masterData.lottery_fail_message ?? ''} onChange={handleChange}></textarea>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
                <label htmlFor="remarks">抽選後はずれ画像</label>
              </div>
              <div className="col-5 align-self-center">
                {!(masterData.uploadfile2) && <input type="file" className="form-control-file" name="lotteryAfterImage" id="lotteryAfterImage" value="" onChange={handleChangeFile2} onClick={e => (e.target.value = null)} />}
                {masterData.uploadfile2 && <object id="uploadfileview" className="w-100" data={masterData.uploadfile2} type={masterData.uploadfiletype2}><img className="w-100" src={masterData.uploadfile2} alt='uploadfile2' /></object>}
                {masterData.uploadfile2 && <input type="button" className="form-controll" name="deletefile2" id="deletefile2" onClick={handleDeleteFile2} value="ファイル削除" />}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
                <span>利用可能ランクID</span>
              </div>
              <div className="col-9 d-flex align-items-center">
                {customerrankData.map((rank, index) => (
                  <div className="form-check mx-2" key={rank.rank_id}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`rank_id_${rank.rank_id}`}
                      name="rank_id"
                      value={rank.rank_id}
                      checked={masterData && Array.isArray(masterData.rank_id) && masterData.rank_id.map(String).includes(String(rank.rank_id))}
                      onChange={handleRankIdChange}
                    />
                    <label className="form-check-label mx-1" htmlFor={`rank_id_${rank.rank_id}`}>
                      {rank.rank_name}
                    </label>
                  </div>
                ))}
                <span className='ml-4'>※未選択の場合、全ランクで利用可能です。</span>
              </div>
            </div>
          </div>
          <div className='col-12'>
            <div className="row my-3 mt-4 d-flex justify-content-center">
              <div className="col-2 text-center">
                <button type="button"
                  className={`btn btn-primary mx-1 w-100 text-nowrap`}
                  disabled={lockData}
                  onClick={() => registerData()}>
                  登録</button>
              </div>
              <div className="col-2 text-center">
                <button type="button"
                  className={`btn btn-primary mx-1 w-100 text-nowrap`}
                  disabled={lockData}
                  onClick={() => handleDeleteClick()}>
                  削除</button>
              </div>
            </div>
          </div>
        </div>} */}
      {(lockData || !masterData) && <Loading />}
      {masterData !== null && (renderList())}
      {renderInput()}
    </div>
  )
}

export default AppLottery;